export const useApi = createUseFetch((callerOptions) => {
  const config = useRuntimeConfig()

  return {
    ...callerOptions,
    baseURL: config.public.apiUrl,
    retryStatusCodes: [401],
    retry: 1
  }
})

export default useApi
